export default __webpack_public_path__ + "static/media/Vending4.19dabcd1.png";